module.exports = __webpack_public_path__ + "static/service-concept2-88c8d62022859c2cf0010672ad79e86a.png";